<template>
  <div class="">
    <b-row align-v="center">
      <b-col cols="11" class="p-0 m-0">
        <b-form @submit.prevent="searchFeature()">
          <b-form-input
              id="input"
              placeholder=" جستجو"
              v-model="searchedWord"
              class="mb-1"
          ></b-form-input>
        </b-form>
      </b-col>
      <b-col cols="1" class="p-0  m-0">
        <b-icon icon="arrow-clockwise" class="d-inline mr-1" @click="refreshFeatures"></b-icon>
      </b-col>
    </b-row>

    <div class="feature_box_selector text-right shadow p-2 rounded">
      <p class="w-100 feature_box_selector_item"
         v-for="feature in dashboardFeature" @click="selectFeature(feature)" v-if="handleFilterFunction(feature)">
        {{ feature.name }}</p>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "FeatureSearch",
  props: {
    filterFunction: {
      default: null
    }
  },
  data() {
    return {
      fields: [
        {key: "name", label: "نام ویژگی"},
        {key: "value", label: "مقدار ویژگی"},
        {key: "extraValue", label: ""},
        {key: "action", label: ""},
      ],
      searchedWord: ''
    };
  },
  computed: {
    ...mapGetters({
      product: 'Product/getProduct',
      dashboardFeature: 'Feature/getFilteredFeatures',
    })
  },
  methods: {
    searchFeature() {
      if (this.searchedWord != "") {
        const searchWord = {words: this.searchedWord};
        this.$store.dispatch("Feature/filteredFeatures", searchWord);
      }
    },
    async refreshFeatures() {
      await this.$store.dispatch("Feature/getFeatures");
    },
    selectFeature(feature) {
      this.$emit('selectedFeature', feature)
    },
    handleFilterFunction(featureItem) {
      if (this.filterFunction != null) {
        return this.filterFunction(featureItem)
      }
      return true
    }
  }
}
</script>

<style scoped>
.feature_box_selector {
  height: 150px;
  width: 100%;
  overflow-x: auto;
}

.feature_box_selector_item {
  cursor: pointer;
}
</style>